import React from 'react';
import { Typography, Box, Alert } from '@mui/material';
import { TransactionForm } from '../components/forms';
import { TRANSACTION_TYPES } from '../constants';

export default function AccountCreditNote() {
  return (
    <Box>
      <Typography variant="h4" sx={{ pl: 3, pt: 2, mb: 1 }}>
        Account Credit Note
      </Typography>
      <Alert severity="warning" variant="filled" sx={{ mx: 3, mb: 2, fontWeight: 'bold' }}>
        You are on the CREDIT NOTE page — this credits the account, not an invoice.
      </Alert>
      <TransactionForm type={TRANSACTION_TYPES.CREDIT_NOTE} />
    </Box>
  );
}